import React, { useEffect } from "react";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import { Title } from "@vds/typography";
import { css } from "@emotion/react";
import { CustomSLButton, FlexRow, SmallText } from "../../components/core/utility";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { Icon } from "@vds/icons";

export const StyledModal = css`
  max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  padding-right: 2px;
  border-radius: 0.5rem !important;
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }

  & footer {
    padding: 0;
  }
`;

const DeleteMMIDModal = ({ deleteMMIDModal, setDeleteMMIDModal, deleteMMID }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setDeleteMMIDModal(false);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, []);

  const handleDeleteMMID = async () => {
    setDeleteMMIDModal(false);
    deleteMMID();
  };

  return (
    <>
      <Modal
        role="dialog"
        ariaLabel="Delete Item"
        hideCloseButton={false}
        opened={deleteMMIDModal}
        disableOutsideClick
        css={StyledModal}
        closeButton={
          <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
            <div>
              <Title size="medium">Delete Item</Title>
            </div>
            <div
              data-testId="close-icon"
              onClick={() => {
                setDeleteMMIDModal(false);
              }}
              style={{ marginRight: "1rem", marginTop: "0.3rem" }}
            >
              <Icon
                aria-label="close"
                alt="close-icon"
                role="img"
                name="close"
                size="medium"
                color="#000000"
                style={{ cursor: "pointer", outline: "none" }}
              />
            </div>
          </FlexRow>
        }
      >
        <ModalBody css={{ paddingLeft: "0", paddingRight: "0", marginTop: "0.5rem" }}>
          <SmallText>Are you sure you would like to delete the item?</SmallText>
        </ModalBody>
        <ModalFooter>
          <FlexRow style={{ paddingTop: "2rem" }}>
            <CustomSLButton
              primary
              aria-label="Delete"
              role="button"
              onClick={() => {
                handleDeleteMMID();
              }}
            >
              Delete
            </CustomSLButton>
            <CustomSLButton
              aria-label="Cancel"
              role="button"
              secondary
              onClick={() => {
                setDeleteMMIDModal(false);
              }}
            >
              Cancel
            </CustomSLButton>
          </FlexRow>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default DeleteMMIDModal;
